export default {
  title: 'Tritt {{name}} bei!',
  default_program_name: 'Rewards Club',
  savings_highlight: {
    title: 'Sammle Punkte mit jeder Bestellung',
    subtitle: 'Melde dich in Sekunden an und sammle Punkte.',
  },
  how_it_works: {
    label: 'So funktioniert es',
    step_1: {
      title: 'Anmeldung in 30s',
      desc: 'Nur deine Handynummer',
    },
    step_2: {
      title: 'Bestellen & verdienen',
      desc: '{{percentage}}% zurück bei jeder Bestellung',
    },
    step_3: {
      title: 'Einlösen & sparen',
      desc: 'Bis zu {{amount}} Rabatt pro Bestellung',
    },
  },
  profile: {
    verified_title: 'Telefon verifiziert!',
    verified_subtitle: 'Vervollständige dein Profil, um loszulegen.',
  },
  form: {
    phone_number: {
      label: 'Handynummer',
      description: 'Wir senden dir einen Bestätigungscode.',
      placeholder: 'Handynummer',
    },
    birthday: {
      label: 'Geburtstag — Tag und Monat reichen für ein Geschenk 🥳',
      placeholder: 'Geburtstag (optional)',
      parts: {
        month: 'Monat',
        day: 'Tag',
      },
    },
  },
  terms:
    'Mit der Anmeldung stimmst du unseren <TermsLink>AGB</TermsLink> und unserer <PrivacyPolicyLink>Datenschutzrichtlinie</PrivacyPolicyLink> zu.',
  buttons: {
    continue: 'Weiter',
    verify: 'Bestätigen',
    complete: 'Anmeldung abschließen',
  },
  toasts: {
    login_success: 'Du hast dich erfolgreich eingeloggt',
    invalid_code: 'Ungültiger Code. Bitte versuche es erneut.',
    failed_to_update_profile: 'Profil kann nicht aktualisiert werden. Bitte versuche es erneut.',
  },
};
